export default __webpack_public_path__ + "static/profnastil-7d62d75defa4d0b9261e247e69d7b921.jpg";